import { htmlToText } from 'crono-fe-common/utils';
import { hasFormattingTag } from 'utils/htmlUtils';

/**
 * A to-do description as the plain-text textarea can show it. Descriptions
 * written by a user are already plain text, the AI-generated ones arrive as
 * markup and would otherwise be read as raw tags. Newlines become `<br>` first
 * because the conversion strips them, which would collapse a plain-text
 * description that happens to contain a tag.
 */
export const genericDescriptionToText = (
  description: string | null | undefined,
): string => {
  if (!description) {
    return '';
  }

  if (!hasFormattingTag(description)) {
    return description;
  }

  return htmlToText(description.replaceAll('\n', '<br>'), true);
};
